import { IProductOption } from "@faire/web-api--source/indigofair/data/IProductOption";
import { IProductVariation } from "@faire/web-api--source/indigofair/data/IProductVariation";
import { ProductVariationType } from "@faire/web-api--source/indigofair/data/ProductVariationType";
import pick from "lodash/pick";
import sortBy from "lodash/sortBy";

import { isPrePackProductOption } from "@faire/retailer-visitor-shared/features/PrePacks/isPrePackProduct";

export const isSizeVariation = (
  variationType?: keyof typeof ProductVariationType
): boolean => variationType === ProductVariationType.SIZE;

/**
 * Convert a variation object into a string key that we can use to index
 * a map of options that may be organized into prepacks.
 */
export const getStyleKeyFromVariations = (
  variations: undefined | IProductVariation[]
): string => {
  const sortedAndFilteredVariations =
    // Sort the variations so that the same variations in different orders still
    // produce the same key
    sortBy(variations, (v) => v.name)
      // Remove size variations, as they're not relevant to a "style"
      .filter((variation) => !isSizeVariation(variation.type))
      // MobX sometimes adds additional properties to our objects, make sure we're
      // only serializing the properties we care about
      .map((v) => pick(v, ["name", "value"]));

  return JSON.stringify(sortedAndFilteredVariations);
};

export const getCurrentStyleHasOnlyPrePacks = (
  optionsByStyle: { [styleKey: string]: IProductOption[] },
  selectedOption: IProductOption | undefined
) => {
  const currentStylesOptions =
    optionsByStyle[getStyleKeyFromVariations(selectedOption?.variations)] || [];

  return (
    currentStylesOptions.length > 0 &&
    currentStylesOptions.every((option) => isPrePackProductOption(option))
  );
};
